/**
 * Created by iamso on 05.08.19.
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TREASURE_SEARCH_TIMER_TEXT: {
        name: "default",
        size: 60,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.styles.TreasureSearchWindow = {
    delay: 11.5,

    content: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: 45 }
    },

    timer: {
        width: 250,

        positions: [{
            x: { align: "center", dx: 0 }, y: { align: "top", dy: -125 }
        }, {
            x: { align: "center", dx: 0 }, y: { align: "top", dy: -145 }
        }, {
            x: { align: "center", dx: 0 }, y: { align: "top", dy: -145 }
        }]
    }
};
